export default {
  chart: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    type: 'area',
    style: {
      overflow: 'visible',
      fontFamily: 'Source Sans Pro Regular, Source Sans Pro, sans-serif',
      fontSize: '15px',
    },
    skipClone: true,
  },
  title: { text: '' },
  credits: { enabled: false },
  xAxis: {
    labels: {
      enabled: false,
      style: { fontSize: '1.4rem' },
    },
    title: { text: null },
    startOnTick: false,
    endOnTick: false,
    tickPositions: [],
    lineColor: 'transparent',
  },
  yAxis: {
    endOnTick: false,
    startOnTick: false,
    labels: {
      enabled: false,
      style: { fontSize: '1.4rem' },
    },
    title: { text: null },
    gridLineColor: 'transparent',
  },
  legend: { enabled: false },
  tooltip: { enabled: false },
  colors: ['black'],
  plotOptions: {
    series: {
      animation: false,
      lineWidth: 1,
      shadow: false,
      states: {
        hover: {
          enabled: false,
          lineWidthPlus: 0,
        },
      },
      marker: { enabled: false },
      fillOpacity: 0,
    },
    area: { step: 'left' },
  },
};
